// ===============================
// Helpers
// ===============================

function getCurrentVariantId() {
  const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  return input ? input.value : null;
}

let product_location_stock = '';
let lastVariantId = null;

let svg_available = '';
let svg_out_of_stock = '';
let svg_delivery_wait = '';


// ===============================
// UI helper
// ===============================

function setLoadingState() {
  const el = document.querySelector('.product-delivery-info .delivery-info');
  if (el) el.classList.add('is-loading');
}

function removeLoadingState() {
  const el = document.querySelector('.product-delivery-info .delivery-info');
  if (el) el.classList.remove('is-loading');
}


// ===============================
// Tooltips
// ===============================

function ReinitiateTooltips() {
  setTimeout(function () {
    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      document.querySelectorAll('.tooltip').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.stopPropagation();

          document.querySelectorAll('.tooltip').forEach(function (t) {
            if (t !== el) t.classList.remove('tooltip--active');
          });

          this.classList.toggle('tooltip--active');
        });
      });

      document.addEventListener('click', function () {
        document.querySelectorAll('.tooltip').forEach(function (el) {
          el.classList.remove('tooltip--active');
        });
      });
    }
  }, 200);
}


// ===============================
// Delivery rendering
// ===============================

function renderExpectedDelivery(date) {

  jQuery('.product-delivery-info').html(
    '<div class="delivery-info expected_delivery_date">' +

      '<div class="delivery-content">' +
        '<span class="delivery-title">' + expected_delivery_date + '</span>' +
        '<span class="delivery-date">' + date + '</span>' +
      '</div>' +

      expected_delivery_date_tooltip +

    '</div>'
  );

  removeLoadingState();
  ReinitiateTooltips();
}


function renderInStock(text, tooltip) {

  jQuery('.product-delivery-info').html(
    '<div class="delivery-info available">' +
      text + tooltip +
    '</div>'
  );

  removeLoadingState();
  ReinitiateTooltips();
}


function renderOutOfStock() {

  jQuery('.product-delivery-info').html(
    '<div class="delivery-info out_of_stock">' +
      svg_out_of_stock + out_of_stock + out_of_stock_tooltip +
    '</div>'
  );

  removeLoadingState();
  ReinitiateTooltips();
}


// ===============================
// Warehouse logic
// ===============================

function SetProductDeliveyByLocationStock(location_stock, selected_variant) {

  const json = JSON.parse(location_stock);
  const today = new Date().getDay();

  let handled = false;

  json.forEach(item => {
    if (item.variant_id != selected_variant) return;

    if (item.location_id == '71945552125' && item.stock > 0) {
      handled = true;

      if (today < 5) {
        renderInStock(svg_available + shipped_today, shipped_today_tooltip);
      } else {
        renderInStock(svg_available + up_two_day_delivery, up_two_day_delivery_tooltip);
      }
    }
  });

  if (!handled) {
    renderInStock(svg_available + next_day_delivery, next_day_delivery_tooltip);
  }
}


function SetProductDeliveyByLocationNOStock(location_stock, selected_variant) {
  renderOutOfStock();
}


// ===============================
// MAIN LOGIC
// ===============================

function updateDeliveryInfo() {

  const selected_variant = getCurrentVariantId();
  if (!selected_variant) return;

  setLoadingState();

  var variant = jQuery('.product-variant-container .variant-' + selected_variant);
  if (!variant.length) return;

  const next_incoming = variant.data('variant-next-incoming-date') || '';
  const next_meta = variant.data('variant-next-meta-incoming-date') || '';
  const inventory = variant.data('variant-inventory-qty') || 0;
  const allowed = variant.data('variant-allowed') || 'deny';

  const deliveryDate = next_meta || next_incoming;

  // OUT OF STOCK
  if (inventory < 1) {

    if (allowed === 'continue') {

      if (deliveryDate) {
        renderExpectedDelivery(deliveryDate);
      } else {

        if (!product_location_stock) {
          fetch(`https://vxelbjibok4efpedz5v6zu7u7q0syjgs.lambda-url.eu-west-2.on.aws/?product_id=` + product_id)
            .then(res => res.text())
            .then(data => {
              product_location_stock = data;
              SetProductDeliveyByLocationNOStock(data, selected_variant);
            });
        } else {
          SetProductDeliveyByLocationNOStock(product_location_stock, selected_variant);
        }

      }

    } else {
      renderOutOfStock();
    }

  }

  // IN STOCK
  else {

    if (!product_location_stock) {
      fetch(`https://vxelbjibok4efpedz5v6zu7u7q0syjgs.lambda-url.eu-west-2.on.aws/?product_id=` + product_id)
        .then(res => res.text())
        .then(data => {
          product_location_stock = data;
          SetProductDeliveyByLocationStock(data, selected_variant);
        });
    } else {
      SetProductDeliveyByLocationStock(product_location_stock, selected_variant);
    }

  }
}


// ===============================
// 🔥 VARIANT OBSERVER
// ===============================

function watchVariantChange() {

  setInterval(function () {

    const currentId = getCurrentVariantId();
    if (!currentId) return;

    if (currentId !== lastVariantId) {
      lastVariantId = currentId;

      setTimeout(updateDeliveryInfo, 80);
    }

  }, 150);

}


// ===============================
// INIT
// ===============================

(function () {

  var nTimer = setInterval(function () {

    if (!window.jQuery) return;

    jQuery(document).ready(function () {

      // initial load (double safe)
      setTimeout(updateDeliveryInfo, 120);
      setTimeout(updateDeliveryInfo, 300);

      // start watcher
      watchVariantChange();

    });

    clearInterval(nTimer);

  }, 100);

})();